import { isIsrael } from "../../../../common-deprecated/settings/utils/commonSettingUtils";

// Some units should always be positioned LTR, also for Israel
export const calculateUnitPosition = (cultureName: string, value: string, unit: string): string => {
    const israel = isIsrael(cultureName);
    if (israel && unit === "°") return `${unit} ${value}`;
    return `${value} ${unit}`;
};
